type TRegistrationAttrs = {
  id?: string | null;
  loadedId?: string | null;
};

// ProseMirror attrs only - the doc-engine's isNodeLoaded reads html attrs and calls an absent one settled.
export const isRegistrationSettled = (attrs: TRegistrationAttrs): boolean => attrs.loadedId === attrs.id;
